import { createTheme } from 'uinix-ui';

import { colors } from '../../tokens/colors';
import { radii } from '../../tokens/radii';
import { shadows } from '../../tokens/shadows';
import { sizes } from '../../tokens/sizes';
import { spacings } from '../../tokens/spacings';
import { zIndices } from '../../tokens/zIndices';
import { animations } from './animations';
import { borders } from './borders';
import { borderWidths } from './borderWidths';
import { fontFamilies } from './fontFamilies';
import { fontSizes } from './fontSizes';
import { fontWeights } from './fontWeights';
import { keyframes } from './keyframes';
import { lineHeights } from './lineHeights';
import { opacities } from './opacities';

export const theme = createTheme({
  animations,
  borders,
  borderWidths,
  colors,
  fontFamilies,
  fontSizes,
  fontWeights,
  keyframes,
  lineHeights,
  opacities,
  radii,
  sizes,
  shadows,
  spacings,
  zIndices,
});
